import { ConnectedPosition } from '@angular/cdk/overlay';
import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { combineLatest, firstValueFrom, startWith } from 'rxjs';
import { AppService } from 'src/app/app.service';
import { CardCenterService } from 'src/app/pages/card-center/card-center.service';
import { KycService } from 'src/app/pages/kyc/kyc.service';
import { LoginService } from 'src/app/pages/login-dialog/login.service';
import { NotificationDialogService } from 'src/app/pages/notification-center/dialog/notification-dialog.service';
import { NotificationService } from 'src/app/pages/notification-center/notification.service';
import { MenuItem, TopMenu } from 'src/app/pages/user-center/left-menu.config';
import { KycApi } from 'src/app/shared/apis/kyc-basic.api';
import { SettingsApi } from 'src/app/shared/apis/settings.api';
import { ThemeSwitchComponent } from 'src/app/shared/components/theme-switch/theme-switch.component';
import { AccountInforData } from 'src/app/shared/interfaces/account.interface';
import { LangModel } from 'src/app/shared/interfaces/country.interface';
import { ChatService } from 'src/app/shared/service/chat.service';
import { CountryUtilsService } from 'src/app/shared/service/country.service';
import { LayoutService } from 'src/app/shared/service/layout.service';
import { LocalStorageService } from 'src/app/shared/service/localstorage.service';
import { PopupService } from 'src/app/shared/service/popup.service';
import { environment } from 'src/environments/environment';

type H5TopMenuComponentUse = 'h5-topMenu' | 'h5-langSelect';

@UntilDestroy()
@Component({
  selector: 'app-h5-top-menu',
  templateUrl: './h5-top-menu.component.html',
  styleUrls: ['./h5-top-menu.component.scss'],
})
export class H5TopMenuComponent implements OnInit {
  theme: string = '';
  logined!: boolean;
  menuDialog?: MatDialogRef<any>;
  menuData: MenuItem[][] = JSON.parse(JSON.stringify(TopMenu));
  popStatus: { [key: string]: boolean } = { user: false };
  containerPositions: ConnectedPosition[] = [
    { originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top', offsetX: 0, offsetY: -8 },
  ];
  currentPage!: string;
  allLangData!: LangModel[];
  useFor!: H5TopMenuComponentUse;

  kycLevel: number = 0;
  kycStatusName!: string;
  messagesCount: number = 0; // 当前有多少信息未读

  /** 用户名 */
  protected userName = 'Unknown';

  /** 卡券数量 */
  protected bounsCount = 0;

  /** 用户头像圖片資源 */
  protected avatarImgSrc = '';

  /** vip圖片資源 */
  protected vipImgSrc = '';

  /** 当前vip等级 */
  protected currentVipLevel = 0;

  /** 是否為超級vip等级 */
  protected isSuperVip = false;

  @Input() vipLoading!: boolean;

  /** kyc状态loading */
  kycStatusLoading: boolean = false;

  sponsors: { name: string; season: string; image: string; imageTheme?: 'default' | 'light' | 'dark' }[] = [
    { name: 'swansea', season: 'season1', image: 'about_us_link_a', imageTheme: 'light' },
    { name: 'milan', season: 'season2', image: 'about_us_link_b' },
    { name: 'villa', season: 'seaon3', image: 'about_us_link_c' },
  ];

  features: { title: string; subtitle: string }[] = [
    { title: 'sen_b', subtitle: 'sen_c' },
    { title: 'user_value', subtitle: 'sen_d' },
    { title: 'game_value', subtitle: 'sen_e' },
  ];
  userInfo: AccountInforData | null = null;

  constructor(
    public chatService: ChatService,
    public loginService: LoginService,
    public appService: AppService,
    private popup: PopupService,
    private layout: LayoutService,
    private kycService: KycService,
    private countryUtils: CountryUtilsService,
    private router: Router,
    private cardCenterService: CardCenterService,
    private kycApi: KycApi,
    private localStorageService: LocalStorageService,
    private notificationDialogService: NotificationDialogService,
    private notificationService: NotificationService,
    private settingsApi: SettingsApi,
  ) {
    //主题色获取
    this.appService.themeSwitch$.pipe(untilDestroyed(this)).subscribe(v => {
      this.theme = v === 'sun' ? 'light' : 'dark';
    });
  }

  ngOnInit() {
    // 订阅当前登录账号信息
    this.appService.userInfo$.pipe(untilDestroyed(this)).subscribe((x: AccountInforData | null) => {
      this.logined = !!x;
      this.userInfo = x;
      this.userName = x?.userName || x?.uid || '';
      this.avatarImgSrc = x?.avater || '';
      this.isSuperVip = x?.isSvip ?? false;
      if (x?.isSVip) return;

      this.currentVipLevel = x?.viPGrade ?? 0;
      this.vipImgSrc = `assets/images/vip/vip_${this.currentVipLevel}.png`;

      combineLatest([this.appService.noticeCounts$, this.appService.updateNoticeCounts$.pipe(startWith(true))])
        .pipe(untilDestroyed(this))
        .subscribe(async ([e, _]) => {
          if (!this.logined) {
            this.messagesCount = 0;
            return;
          }
          const config = await firstValueFrom(this.settingsApi.getNoticeConfig());
          const noticeTypeList: any[] = config?.data?.noticeTypeList || [];
          const total = noticeTypeList.reduce((acc, item) => {
            return acc + (e?.[item] || 0);
          }, 0);
          this.messagesCount = total || 0;

          if (this.messagesCount === 0) {
            this.notificationService.isReadedAll$.next(true);
          } else {
            this.notificationService.isReadedAll$.next(false);
          }
        });

      // 获取站内信 所有信息
      if (this.logined) {
        this.notificationService.getNoticeCounts();
      }
    });

    // 订阅当前路由页
    this.layout.page$.pipe(untilDestroyed(this)).subscribe(v => (this.currentPage = v));

    // 本地获取语言数据
    this.appService.languages$.pipe(untilDestroyed(this)).subscribe(x => (this.allLangData = x));

    // 接收全局打开语言选择请求
    this.appService.h5LangSelectPop$.pipe(untilDestroyed(this)).subscribe(v => {
      if (v) this.open('h5-langSelect');
    });

    this.cardCenterService.bounsCount$.pipe(untilDestroyed(this)).subscribe(bounsCount => {
      this.bounsCount = bounsCount || 0;
    });

    //非H5关闭菜单
    this.layout.isH5$.pipe(untilDestroyed(this)).subscribe(x => !x && this.close());
  }

  /** 获取用户当前KYC状态 */
  onGetKycStatus() {
    if (this.localStorageService.loginToken) {
      this.kycStatusLoading = true;
      this.kycApi.getUserKycStatus().subscribe(data => {
        if (data.length > 0) {
          const currentKyc = this.kycService.checkUserKycStatus(data);
          this.kycLevel = currentKyc.level;
          this.kycStatusName = currentKyc.kycStatusName;
        }
        this.kycStatusLoading = false;
      });
    }
  }

  /**
   * 跳转在线客服
   */
  goService() {
    this.appService.toOnLineService$.next(true);
    this.close();
  }

  @ViewChild('themeSwitch') themeSwitch!: ThemeSwitchComponent;
  @ViewChild('menuPopup') menuPopup!: TemplateRef<any>;

  open(to: H5TopMenuComponentUse) {
    this.useFor = to;
    if (this.menuDialog) return;
    this.menuDialog = this.popup.open(this.menuPopup, {
      inAnimation: 'fadeInRight',
      outAnimation: 'fadeOutRight',
      speed: 'fast',
      autoFocus: false,
      isFull: true,
    });

    this.onGetKycStatus();
  }

  getImageThemeUrl(url: string, imageTheme?: string) {
    if (imageTheme === 'default' || imageTheme === this.theme) {
      const n = url.split('.');
      return `${n[0]}-${this.theme}.${n[1]}`;
    }
    return url;
  }

  menuClick(item: MenuItem, event: any) {
    if (item.icon == 'bell-filled') {
      this.notificationDialogService.openNotification(1);
    }

    if (item.icon == 'logout-right-filled') {
      this.appService.saveUrl();
      this.appService.logoutSubject$.next(true);
      return;
    }

    if (item.icon == 'kefu') {
      this.appService.toOnLineService$.next(true);
      this.close();
      return;
    }
    if (item.icon == 'chat-vip') {
      this.chatService.toggleChat(true);
      this.close();
      return;
    }
    //登出
    if (item.icon === 'exit') {
      this.appService.saveUrl();
      this.appService.logoutSubject$.next(true);
      this.close();
      return;
    }

    //切换语言
    if (item.icon === 'global') {
      this.useFor = 'h5-langSelect';
      return;
    }

    //展开子级
    if (item.children) {
      const parent: Element = event.currentTarget;
      const children: Element | null = parent.nextElementSibling;
      if (children) {
        parent.classList.toggle('expand');
        children.classList.toggle('show');
      }
      return;
    }

    this.close();
  }

  close() {
    this.menuDialog?.close();
    this.menuDialog = undefined;
  }

  jumpToLogin() {
    this.appService.saveUrl();
    this.close();
  }

  checkGroup(target: MenuItem[]): boolean {
    return target.some(item => {
      return this.checkItem(item);
    });
  }

  checkItem(target: MenuItem): boolean {
    let result;
    if (target.showOnTourist) {
      result = !target.showOnly || target.showOnly === 'h5' || (target.showOnly === 'app' && environment.isApp);
      if (target.showOnlyTourist && this.logined) result = false;
    } else {
      if (!this.logined) {
        result = false;
      } else {
        result = !target.showOnly || target.showOnly === 'h5' || (target.showOnly === 'app' && environment.isApp);
      }
    }
    if (result && target.children) result = this.checkGroup(target.children);
    if (target.icon === 'chat-vip' && !this.chatService.chatEnabled) result = false;
    return result;
  }

  countryClassName(code: any) {
    return this.countryUtils.getcountryClassName(code);
  }

  getRouterLink(target: MenuItem): string | null {
    return !target.page || target.children ? null : target.page;
  }

  getRouterLinkActive(target: MenuItem): string {
    return !target.page || target.children ? '' : 'active';
  }

  /**
   * Kyc跳转
   */
  jumpToKyc() {
    //if (this.kycLevel > 1) return;
    this.router.navigate([this.appService.languageCode, 'userCenter', 'kyc']);
    this.close();
  }

  /**
   * 选择语言
   */
  langCode: string = this.appService.languageCode;
  selectLang(selectedLang: LangModel) {
    const targetCode = selectedLang.code.toLowerCase();
    if (this.appService.languageCode === targetCode) return;
    this.appService.selectLangFun(targetCode);
  }
}
